export * from "./SticksProductDetails";
